import type { InsightsInsightsPageQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type EmployeesAgeHeadcount =
  InsightsInsightsPageQuery['employees']['ageHeadcountsConnection']['nodes'][number]

import { ExportRow, GenerateExport } from './export'

export default class EmployeesAverageAge implements GenerateExport {
  private employeesAgeHeadcount: EmployeesAgeHeadcount[]

  constructor(headcountByGender: EmployeesAgeHeadcount[]) {
    this.employeesAgeHeadcount = headcountByGender
  }

  isEmpty() {
    const result = this.generate()
    return isNaN(result) || result <= 0
  }

  export() {
    const data: ExportRow[][] = [[i18n.t('insights.widgets.employee_average_age.years')]]

    const result = this.generate()
    data.push([result])

    return {
      title: i18n.t('insights.widgets.employee_average_age.title'),
      data: data,
    }
  }

  generate() {
    return this.calculateWeightAverage()
  }

  calculateWeightAverage() {
    let ages = 0
    let employees = 0

    this.employeesAgeHeadcount.forEach(({ age, count }) => {
      ages += age * count
      employees += count
    })

    if (employees == 0) return 0

    return ages / employees
  }
}
